<div [formGroup]="group" class="field" [ngClass]="{ hidden: field.hidden }">
    <!--- multipe checkbox-->
    <ng-container *ngIf="field.fieldType === 'checkbox'">
        <p>
            <label for="{{ field.name }}-{{ formId }}" id="label-{{ field.name }}-{{ formId }}"
                >{{ field.label }}<span *ngIf="field.required" class="is-required">*</span></label
            >
            <ng-container *ngIf="field.description">
                <span class="hint">{{ field.description }}</span>
            </ng-container>
        </p>
        <ul class="reset" role="checkbox">
            <li *ngFor="let checkbox of field.options; let i = index" class="checkbox-control">
                <label for="{{ field.name }}{{ i + 1 }}-{{ formId }}" class="checkboxlabel">
                    <input
                        type="checkbox"
                        id="{{ field.name }}{{ i + 1 }}-{{ formId }}"
                        (change)="onChecklistChange($event.target.checked, checkbox)"
                        [checked]="checkbox.checked"
                        [value]="checkbox.value"
                    />
                    <span class="checkboxlabelvalue">
                        <span>{{ checkbox.label }}</span>
                        <span>{{ checkbox.description }}</span>
                    </span>
                </label>
            </li>
        </ul>
    </ng-container>
    <ng-container *ngIf="field.fieldType === 'booleancheckbox'">
        <p>
            <label for="{{ field.name }}-{{ formId }}" id="label-{{ field.name }}-{{ formId }}" class="checkboxlabel">
                <input id="{{ field.name }}-{{ formId }}" type="checkbox" [formControlName]="field.name" />
                <span class="checkboxlabelvalue">
                    <span>{{ field.label }}<span *ngIf="field.required" class="is-required">*</span></span>
                    <span *ngIf="field.description && field.description !== ''" class="description">{{ field.description }}</span>
                </span>
            </label>
        </p>
    </ng-container>
    <!-- single checkbox -->
    <ng-container *ngIf="showErrors$ | async">
        <ng-container *ngFor="let error of group.get(field.name).errors | getIterableErrors">
            <span class="error-msg">{{ getErrorTranslation(error) }}</span>
        </ng-container>
    </ng-container>
    <ng-container *ngFor="let dependentField of field.dependentFieldFilters">
        <ng-container *ngIf="getVisibilityByDependentFieldFiltersAndSetValidators(dependentField, group.get(field.name))">
            <div class="row">
                <ng-container
                    daDynamicField
                    [control]="dependentField.dependentFormField"
                    [reactiveFormData]="group"
                    [formId]="formId"
                ></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
